<template>
  <div class="hidden lg:block" />
</template>
<script setup>
import { onMounted } from 'vue';
import builder from '../../shared/builders/dataLayer';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  prices: {
    type: Object,
    required: true,
  },
  netwaveCategoryCode: {
    type: Number,
    required: true,
  },
});

const { viewItemEvent, reset: resetBuilder } = builder();

onMounted(() => {
  window.dataLayer.push(resetBuilder());
  window.dataLayer.push(viewItemEvent(props.product, props.prices, props.netwaveCategoryCode));
});
</script>
